import { useState } from "react";
import { DEFAULT_OPTION, SORT_OPTIONS } from "./utils/constants";
import "./index.scss";

export const DropdownSortSearch = ({ onChangeSort }) => {
  const [selectedValue, setSelectedValue] = useState(DEFAULT_OPTION);

  const handleChangeSelect = (value) => {
    const parsedSelectedValue = JSON.parse(value);
    onChangeSort(parsedSelectedValue);
    setSelectedValue(parsedSelectedValue);
  };

  return (
    <select
      name="sort-search"
      className="sort-search"
      value={JSON.stringify(selectedValue)}
      onChange={(e) => handleChangeSelect(e.target.value)}
    >
      {SORT_OPTIONS.map((item) => (
        <option
          className="option-search"
          value={JSON.stringify(item.value)}
          key={item.label}
          label={item.label}
        />
      ))}
    </select>
  );
};
